import {
  GET_NOTIFICATION,
  GET_NOTIFICATIONS,
  NOTIFICATION_ERROR,
  DELETE_NOTIFICATION,
  ADD_NOTIFICATION,
  UPDATE_NOTIFICATION
} from '../actions/types';

const initialState = {
  notification: null,
  notifications: [],
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_NOTIFICATION:
      return {
        ...state,
        notification: payload,
        loading: false
      };
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload,
        loading: false
      };
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [payload, ...state.notifications],
        loading: false
      };
    case UPDATE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map(item => 
          item._id === payload._id ? payload : item
        ),
        notification: payload,
        loading: false
      };
    case DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(item => item._id !== payload),
        loading: false
      };
    case NOTIFICATION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
